import { render, staticRenderFns } from "./PublishDialog.vue?vue&type=template&id=12cad28e&scoped=true&"
import script from "./PublishDialog.vue?vue&type=script&lang=ts&"
export * from "./PublishDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PublishDialog.vue?vue&type=style&index=0&id=12cad28e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cad28e",
  null
  
)

export default component.exports